import { useState } from 'react';
import clsx from 'clsx';
import { Chip } from './Chip';

export const TabList = ({
  tabs,
  active,
  setActive,
  className,
  wrapperClassName,
}) => {
  const [activeTab, setActiveTab] = useState(active);

  return (
    <div
      className={clsx(
        'flex items-center justify-center border border-solid border-fadedgrey rounded-lg p-1',
        wrapperClassName
      )}
    >
      {tabs.map((tab, index) => (
        <Chip
          className={clsx('flex items-center text-secondary-button', className)}
          key={index}
          mode={'select'}
          content={tab}
          selected={activeTab === index}
          handleAction={() => {
            setActiveTab(index);
            setActive(index);
          }}
        />
      ))}
    </div>
  );
};
